import { Navigate, Outlet } from "react-router-dom";
import useAuthState from "../../state/auth.state";
import { Role } from "../../models/Jwt";

type Props = {
  authorizedRole: Role;
};

function RoleGuard({ authorizedRole }: Props) {
  const { role } = useAuthState();

  if (role !== authorizedRole) {
    return <Navigate to="/forbidden" />;
  }

  return <Outlet />;
}

export default RoleGuard;
